import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import "flatpickr/dist/flatpickr.css";
import 'react-tooltip/dist/react-tooltip.css';
import "moment/locale/ru";
import 'aframe';

import "./shared/lib/string/prototypePolyfills";
import "./log";
import "./error";
import "./init";

import PagesRouter from '#app/pagesRouter/pagesRouter';
import configureStore from '#app/store/configureStore';

import { theme } from './themes';

import './assets/css/normalize.css';
import './assets/css/main.css';
import './assets/css/treemap.css';
import './assets/css/activeslegend.css';
import './assets/css/popup.css';
import './assets/css/index.css';
import "./assets/css/calendar.css";

const store = configureStore();
const root = ReactDOM.createRoot(document.getElementById('app'));

root.render(
	<BrowserRouter future={{
		v7_startTransition: true,
		v7_relativeSplatPath: true
	}}>
		<ThemeProvider theme={theme}>
			<Provider store={store}>
				<PagesRouter />
			</Provider>
		</ThemeProvider>
	</BrowserRouter>
);